module.exports = __webpack_public_path__ + "img/secondary-button-text-color.35c21132.svg";